import BaseCommand from "@/models/api/commands/BaseCommand";

export class ChangeIsBlockedToInvoiceCommand extends BaseCommand {
  CommandName = "ChangeIsBlockedToInvoice";
  Command: {
    Value: boolean;
    BookingItemTmpId: string;
  };
  constructor(sessionId: string, operationId: string, bookingItemTmpId: string, isBlockedToInvoice: boolean) {
    super(sessionId, operationId);
    this.Command = { BookingItemTmpId: bookingItemTmpId, Value: isBlockedToInvoice };
  }
}
